export default "/images/iso_logo__large.png";